module.exports = __webpack_public_path__ + "img/ic_caret_down.f9d6f78c.svg";